'use client';

import { Bug, BugOff } from 'lucide-react';

import { useDebugMode } from '@/components/providers/debug-mode-provider';
import { Button } from '@/components/ui/button';

export function DevToolsButton() {
  const { isDebugMode, toggleDebugMode, showToggle } = useDebugMode();

  if (!showToggle) {
    return null;
  }

  return (
    <Button
      variant="ghost"
      dir="ltr"
      className="aui-dev-tools-button h-7 gap-1.5 px-2 text-xs font-medium text-muted-foreground hover:text-accent-foreground data-[debug=true]:text-foreground"
      onClick={toggleDebugMode}
      aria-label="Debug"
      aria-pressed={isDebugMode}
      data-debug={isDebugMode}
      suppressHydrationWarning
    >
      <Bug className="hidden size-4 [[data-debug=true]>&]:block" />
      <BugOff className="block size-4 [[data-debug=true]>&]:hidden" />
      <span>Debug</span>
    </Button>
  );
}
